export abstract class Validator {
  protected validate() {
    return {
      string: function (value: unknown): string {
        if (typeof value !== 'string') return '';
        return value;
      },
      currency: function (value: unknown): string {
        const usAmountRegex = /((US?\$) (\d{1,3})((,\d{3})+)?(\.(\d{2})))/;
        const amountRegex = /([A-Z]{1,2}\$) (\d{1,3})((\.\d{3})+)?(,(\d{2}))/;

        if (typeof value !== 'string') return '';
        else if ((usAmountRegex.test(value) || amountRegex.test(value)) === false)
          return '';

        return value;
      },
      date(value: unknown): Date | null {
        if (!(value instanceof Date)) return null;
        return value;
      },
      number(value: unknown): number {
        if (typeof value === 'number') return value;
        if (typeof value === 'string') {
          const parsed = parseFloat(value);
          return isNaN(parsed) ? 0 : parsed;
        }
        return 0;
      },
    };
  }
}
